import {
  Button,
  Modal,
  ModalActions,
  ModalContent,
  ModalHeader,
  Text,
} from '@lightspeed/design-system-react'
import { T } from '@transifex/react'
import React, { FunctionComponent } from 'react'

interface ExitTrainingModeModalProps {
  cancel: () => void
  confirm: () => void
}

export const ExitTrainingModeModal: FunctionComponent<ExitTrainingModeModalProps> = ({
  cancel,
  confirm,
}) => {
  return (
    <Modal>
      <ModalHeader>
        <T _str="Exit Training Mode?" />
      </ModalHeader>
      <ModalContent>
        <Text tag="p">
          <T _str="Once you've left training mode, any sales and payments you make from now on will be recorded." />
        </Text>
        <Text tag="p">
          <T _str="To do more training later, click 'Enable training mode' in the Register settings menu." />
        </Text>
      </ModalContent>
      <ModalActions>
        <div className="vd-btn-group">
          <Button onClick={cancel} variant="supplementary">
            <T _str="Continue training" />
          </Button>
          <Button onClick={confirm} variant="go">
            <T _str="Exit training" />
          </Button>
        </div>
      </ModalActions>
    </Modal>
  )
}
